/**
 * Pure maths for the CPC calculator. Kept out of the widget so the numbers on
 * the page can be checked without rendering anything.
 *
 * Conventions: money in dollars, CTR as a percentage (1.2 means 1.2%), the
 * way every ad platform reports it. Every function returns NaN rather than
 * throwing when the inputs cannot produce a number (blank, zero divisor,
 * negative), so the widget only has to check `Number.isFinite`.
 */

/** CPC = spend ÷ clicks. */
export function cpcFromSpend(spend: number, clicks: number): number {
  if (!(spend >= 0) || !(clicks > 0)) return NaN
  return spend / clicks
}

/** Spend = CPC × clicks. */
export function spendFromCpc(cpc: number, clicks: number): number {
  if (!(cpc >= 0) || !(clicks >= 0)) return NaN
  return cpc * clicks
}

/** Clicks = spend ÷ CPC. */
export function clicksFromCpc(spend: number, cpc: number): number {
  if (!(spend >= 0) || !(cpc > 0)) return NaN
  return spend / cpc
}

/**
 * Effective CPC of a campaign bought per impression:
 * CPC = CPM ÷ (1,000 × CTR as a fraction) = CPM ÷ (10 × CTR%).
 */
export function cpcFromCpmCtr(cpm: number, ctrPct: number): number {
  if (!(cpm >= 0) || !(ctrPct > 0) || ctrPct > 100) return NaN
  return cpm / (1000 * (ctrPct / 100))
}
